import React, { useState } from 'react'

import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout'
import { getTranslateByKey } from '@/main/services/utils'

import FiltersSearchHolidays from './filtersSearchHolidays/filtersSearchHolidays'
import { PaginationEnum } from '@/main/services/enum/PaginationEnum'
import { withQueryparams } from '@/main/components/core/queryParams/queryparams'
import { HolidaysRequest } from '@/main/models/request/holidaysRequest'
import { HolidaysResponse } from '@/main/models/response/holidaysResponse'
import GridSearchHoliday from './gridHoliday/gridHolidaysScreen'


function SearchHolidaysScreen() {
  const [dataGrid, setDataGrid] = useState<HolidaysResponse[]>([])
  const [formFilters, setFormFilters] = useState<HolidaysRequest | null>(null)

  function onResetSearch() {
    setDataGrid([]);
    setFormFilters(null);
  }

  async function getDataHolidays(filters: HolidaysRequest | Partial<HolidaysRequest> = {}, isResetSearch: boolean = true) {
    const request: HolidaysRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...filters as HolidaysRequest,
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30,
    };

    onResetSearch()
    setFormFilters(request);
  }

  const titlePage = `${getTranslateByKey('module.registration')} > ${getTranslateByKey('screen.holiday')}`
  return (
    <ContainerScreen title={titlePage}>
      <FiltersSearchHolidays
        formFilters={formFilters}
        getDataHolidays={getDataHolidays}
        onResetSearch={onResetSearch}
      />
      <GridSearchHoliday
        formFilters={formFilters}
        dataGrid={dataGrid}
        setDataGrid={setDataGrid}
      />
    </ContainerScreen>
  )
}

export default withQueryparams(SearchHolidaysScreen)